import { render, staticRenderFns } from "./exchange-details.vue?vue&type=template&id=69eebc52&scoped=true"
import script from "./exchange-details.ts?vue&type=script&lang=ts&external"
export * from "./exchange-details.ts?vue&type=script&lang=ts&external"
import style0 from "./exchange-details.scss?vue&type=style&index=0&id=69eebc52&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69eebc52",
  null
  
)

export default component.exports